import { render, staticRenderFns } from "./sub-title.vue?vue&type=template&id=342736af&scoped=true"
import script from "./sub-title.vue?vue&type=script&lang=js"
export * from "./sub-title.vue?vue&type=script&lang=js"
import style0 from "./sub-title.vue?vue&type=style&index=0&id=342736af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342736af",
  null
  
)

export default component.exports